/* eslint-disable max-len */
import React, { useState, useRef, useEffect,useContext } from 'react';
import CustomOverLay from '../../../../../components/CustomOverLay';
import GlobalContext from '../../../../../components/Context/GloablContext';
import Emptyscreenwithouttitle from '../../../../../components/Emptyscreenwithouttitle';
import { useGetProviderAssociatedToPatientListQuery } from '../../../../../slices/patientSlice';
import formatMobileNumber from '../../../../../CommonMethods/FormatMobileNumber';

export default function PatientProviderList({patient_id}) {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const [queryParams,setQueryParams]=useState(`${patient_id}`)
    const {data,isFetching,isLoading,status}=useGetProviderAssociatedToPatientListQuery(patient_id,{refetchOnMountOrArgChange:true})

    return (
        <>  
            {<>
                <div className='border border-[#EDD7E1] mt-8 rounded'>
                    <div className='relative flex border-b border-[#EDD7E1] justify-between items-center py-3.5 pr-4 pl-[18px]'>
                        <p id='Provider-List' className='text-base font-semibold text-[#972E4C]'>Providers List</p>
                    </div>
                    {data?.data && data?.data.length === 0
                        ? <Emptyscreenwithouttitle customHeight={false} FirstPTag={"No providers linked yet"} />
                        :
                        <div data-testid='Provider-table' className='overflow-auto scrollbar_purple pb-2'>
                            { ((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Provider List..." classKey={` top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-auto ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>: <>
                                <table aria-label="Outside Table" className="w-full table-auto">
                                    <thead>
                                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm z-[1] sticky top-0 left-0">
                                            <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm min-w-[160px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Provider ID
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[200px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Provider Name
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[160px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Main Number
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[110px] rounded-tl-sm rounded-bl-sm">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Send Alert
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[145px] rounded-tl-sm rounded-bl-sm">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Preference Mode
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[116px] rounded-tl-sm rounded-bl-sm">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                    Billing Agent
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.data && data?.data?.length>0 && data?.data?.map((Provider, index) => (
                                            <tr key={index}>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Provider?.providerUserData?.user_id}
                            
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Provider?.providerUserData?.last_name}, {Provider?.providerUserData?.first_name}
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Provider?.providerUserData?.main_no_country_code} {formatMobileNumber(Provider?.providerUserData?.main_number)}
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal">
                                                    <span className={`${Provider?.providerUserData?.send_alert===false ? 'bg-[#E7EAF4] text-[#000000] px-1.5 py-0.5 rounded-[28px]' : 'bg-[#C0ECCE] text-[#1A883C] px-1.5 py-0.5 rounded-[28px]'}`}>
                                                        {Provider?.providerUserData?.send_alert===false ? "Disable" : "Enable"}
                                                    </span>
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal">
                                                    <div className="flex items-center justify-start">
                                                        <img loading="lazy" decoding="async" src={`${Provider?.providerUserData?.preference_mode==="email"?"/images/PreferenceEmail.svg":'/images/PreferencePhone.svg'}`} alt="icon" />
                                                        <span className="text-sm text-start font-normal text-[#000000] pl-2">{Provider?.providerUserData?.preference_mode==="email" ? "Email" : "Call"}</span>
                                                    </div>
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal">
                                                    <span className={`${Provider?.providerUserData?.billing_agent===false ? 'bg-[#E7EAF4] text-[#000000] px-1.5 py-0.5 rounded-[28px]' : 'bg-[#C0ECCE] text-[#1A883C] px-1.5 py-0.5 rounded-[28px]'}`}>
                                                        {Provider?.providerUserData?.billing_agent===false ? "Disable" : "Enable"}
                                                    </span>
                                                </td>
                                            </tr>

                                        ))}
                            
                                    </tbody>
                                </table>
                    
        
                            </>}
                        </div>
                    }
                </div>
            </>}
        </>
    )
}
